import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/scholarships', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/scholarships', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (acps_id, grade_definition_id, Options = {}) => {
  return httpClient
    .get(`/api/scholarships/${acps_id}/${grade_definition_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/scholarships/${data.acps_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (acps_id, grade_definition_id) => {
  return httpClient
    .delete(`/api/scholarships/${acps_id}/${grade_definition_id}`)
    .then(response => Promise.resolve(response.data))
}

export const getMainProgram = (Options = {}) => {
  return httpClient
    .get('/api/scholarships/main-programs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getGrading = (acpId, Options = {}) => {
  return httpClient
    .get(`/api/scholarships/grading-definitions/${acpId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubProgram = (acpId, Options = {}) => {
  return httpClient
    .get(`/api/scholarships/sub-programs/${acpId}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getMainProgram,
  getGrading,
  getSubProgram
}
